












import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "OutlinedArea",

  props: {
    label: {
      type: String,
      default: ""
    }
  },

  setup() {
    return {};
  }
});
